import React, { Component } from 'react'
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

class ScoreControl extends Component {
    constructor(props) {
        super(props)
        this.number = props.number;
        this.type = props.type;
        this.state = { rated: props.rated };
        this.ratingClass = '';
        if (this.state.rated) {
            this.ratingClass = 'rated ';
        }
    }

    componentWillReceiveProps(newProps) {
        if(undefined !== newProps) {
            this.setState({rated: newProps.rated})
        }
    }

    ratingClick = () => {
        this.props.handleRatingClick(this.number);
    }

    renderThumb() {
        let icon = '';
        switch(this.number) {
            case 1:
                icon = 'thumbs-down';
                break;
            case 2:
                icon = 'meh';
                break;
            case 3:
                icon = 'thumbs-up';
                break;
            default:
                icon = '';
                break;
        }

        return (
            <div className={this.ratingClass + "rating-thumb " + this.number} onClick={this.ratingClick}>
                <FontAwesomeIcon
                    className={"rating-icon"} icon={icon}/></div>
        )
    }

    renderStar(){
        return (
            <div className={this.ratingClass + "rating-star " + this.number} onClick={this.ratingClick}>
                <FontAwesomeIcon
                    className={"rating-icon"} icon="star"/></div>
        )
    }

    render() {
        this.ratingClass = this.state.rated ? 'rated ' : ' ';
        return this.type === 'star' ? this.renderStar() : this.renderThumb();
    }
}

export default ScoreControl